export const BACKEND_URL = Object.freeze({
    Base: process.env.VUE_APP_DS_BACKEND_BASE_URL,
    Login: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/login',
    Checkout: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/checkout/order',
    CheckoutSetup: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/checkout/setup',
    Coupon: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/checkout/coupon',
    CheckEmail: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/accounts',
    CheckVat: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/checkout/vat',
    RecoverPasswordInfo: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/accounts/password-recovery',
    ResetPasswordForm: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/accounts/password-recovery-form',
    FreeSignup: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/accounts/free-signup',
    TrialSignup: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/accounts/trial-signup',
    ListSubscriptions: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/customers/VAR_CUSTOMER_ID/subscriptions',
    LastSubscription: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/customers/VAR_CUSTOMER_ID/subscriptions/last',
    CancelSubscription: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/customers/VAR_CUSTOMER_ID/subscriptions/cancel',
    FetchContactId: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/customers/VAR_CUSTOMER_ID/ontraport-data',
    FriendsEmailsForm: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/customers/VAR_CUSTOMER_ID/friend-referral',
    ContactFormMessage: process.env.VUE_APP_DS_BACKEND_BASE_URL + '/contact-forms',
});

export const FRONTEND_URL = Object.freeze({
    WebUrl: process.env.VUE_APP_DS_WEB_URL,
    AppUrl: process.env.VUE_APP_DS_APP_URL,
    MyUrl: process.env.VUE_APP_DS_MY_URL,
    BuyUrl: process.env.VUE_APP_DS_BUY_URL,
    WebTermsAndConditions: process.env.VUE_APP_DS_WEB_URL + '/terms-and-conditions',
    WebPricing: process.env.VUE_APP_DS_WEB_URL + '/pricing',
    WebBlog: process.env.VUE_APP_DS_WEB_URL + '/blog',
    WebSupport: process.env.VUE_APP_DS_WEB_URL + '/support',
    AppLoginPage: process.env.VUE_APP_DS_APP_URL + '/login',
    AvatarURL: process.env.VUE_APP_DS_APP_URL + '/api/containers/medium_avatar/download/',
});

export const STRIPE = Object.freeze({STRIPE_PUB_KEY: process.env.VUE_APP_STRIPE_PK});

export const FACEBOOK = Object.freeze({PIXEL_ID: process.env.VUE_APP_FACEBOOK_PIXEL_ID});
